/**
 * @author Camilo Ramirez
 * @Copyright (c)  Infotrack. All rights reserved.
 */
import ModeloTipoConteoAuditoria from 'Infotrack@Modelos/smartStock/tipoConteoAuditoria';
import ITipoConteoAuditoria from 'Infotrack@Modelos/smartStock/tipoConteoAuditoria/entidades/ITipoConteoAuditoria';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';

export default class ControladorModeloTipoConteoAuditoria {
    private modeloTipoConteoAuditoria: ModeloTipoConteoAuditoria;
    constructor() {
        this.modeloTipoConteoAuditoria = new ModeloTipoConteoAuditoria();
    }

    public async consultarTipoConteoAuditoria() {
        const {
            data: { Entidades },
        } = await this.modeloTipoConteoAuditoria.consultarTipoConteoAuditoria();
        return Entidades;
    }

    public async crearTipoConteoAuditoria(tipoConteoAuditoria: ITipoConteoAuditoria) {
        await this.modeloTipoConteoAuditoria.crearTipoConteoAuditoria(tipoConteoAuditoria);
    }

    public async editarTipoConteoAuditoria(tipoConteoAuditoria: ITipoConteoAuditoria) {
        await this.modeloTipoConteoAuditoria.editarTipoConteoAuditoria(tipoConteoAuditoria);
    }
    public async eliminarTipoConteoAuditoria(tipoConteoAuditoria: ITipoConteoAuditoria) {
        await this.modeloTipoConteoAuditoria.eliminarTipoConteoAuditoria(tipoConteoAuditoria);
    }

    public validarEntidad(tipoConteoAuditoria: ITipoConteoAuditoria): boolean {
        if (
            !tipoConteoAuditoria.DescripcionTipoConteo ||
            !tipoConteoAuditoria.IdEmpresa ||
            !tipoConteoAuditoria.IdAgencia
        ) {
            notificacionGlobal('comunes.alerta.camposIncompletos', 3000, 'warning', true);
            return false;
        }
        return true;
    }
}
